module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'o9gmhbqc',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
